import { FeaturedIcon } from '@prishapolicy/shared/ui';
import { folder, posp } from '@prishapolicy/w3/assets';
import Image from 'next/image';
import CheckLineIcon from 'remixicon-react/CheckLineIcon';

const informationArray = [
  {
    heading: 'Becoming a POSP',
    title: 'All the needs to kickstart your Journey',
    desc: [
      'Min 18 years of age',
      'Marksheet or degree certificate of 10th & above class',
      'Copy of PAN & Aadhar card',
      'Address proof',
      'Copy of cancelled cheque or bank account statement',
    ],
  },
  {
    heading: 'Working with PrishaPolicy',
    title: 'Benefits to make your life easy',
    desc: [
      'Free tailored advice from product & domain experts',
      'Dedicated claim support',
      'Seminar other than training to keep learning on next level',
      'Payout is fair, predefined and time bound by automated processes',
      'Digital passbook to track your business through portal',
    ],
  },
];
export const PospDetail = () => {
  const information1 = informationArray[0];
  const information2 = informationArray[1];

  return (
    <div className="container flex flex-col gap-32 bg-white py-[60px]">
      <div className="grid grid-cols-1 items-center gap-9 xl:grid-cols-2">
        <div className="flex flex-col gap-3">
          <div className="bg-primary h-[5px] w-[50px] rounded-lg"></div>
          <p className="text-title-7 md:text-title-6 lg:text-title-6 text-primary font-medium">
            {information1.heading}
          </p>
          <h1 className="text-title-4 font-bold md:text-[40px]  lg:text-[40px]">{information1.title}</h1>
          <div className="flex flex-col gap-6">
            {information1.desc.map((description, idx) => (
              <div className=" flex items-center gap-5" key={idx}>
                <FeaturedIcon icon={CheckLineIcon} theme="solid" size="md" />
                <p className="text-body-1 md:text-title-6 lg:text-title-6 font-normal">{description}</p>
              </div>
            ))}
          </div>
        </div>
        <div>
          <div className="flex justify-center">
            <Image src={folder} width={536} height={350} alt="cloud" />
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 items-center gap-9 xl:grid-cols-2">
        <div className="order-2 xl:order-1">
          <div className="flex justify-center">
            <Image src={posp} width={536} height={350} alt="cloud" />
          </div>
        </div>
        <div className="order-1 flex flex-col gap-3 xl:order-2">
          <div className="flex justify-start xl:justify-end">
            <div className="bg-primary mb-[3px]  h-[5px] w-[50px] rounded-lg"></div>
          </div>
          <p className="text-title-7 md:text-title-6 lg:text-title-6 text-primary text-left font-medium xl:text-right">
            {information2.heading}
          </p>
          <h1 className="text-title-4 text-left font-bold md:text-[40px]  lg:text-[40px] xl:text-right">
            {information2.title}
          </h1>
          <div className="flex flex-col gap-6">
            {information2.desc.map((description, idx) => (
              <div className="flex items-center justify-start gap-5 xl:justify-end" key={idx}>
                <p className="text-body-1 md:text-title-6 lg:text-title-6 order-2 text-left font-normal xl:order-1 xl:text-right">
                  {description}
                </p>
                <FeaturedIcon icon={CheckLineIcon} theme="solid" size="md" className="order-1 xl:order-2" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
